import { useMutation } from '@tanstack/react-query';
import { authRegisterCreate } from '@wellstone-solutions/api/v2';

import type { Register } from '@wellstone-solutions/api/v2';
import type { AxiosError, AxiosResponse } from 'axios';

const useCreateRegistration = () => {
  return useMutation<
    AxiosResponse<Register>,
    AxiosError<{ [key: string]: string[] }>,
    Register
  >({
    mutationFn: authRegisterCreate,
  });
};

export { useCreateRegistration };
